import { PaymentMethod, PaymentStatus, PaymentType } from '@massilia/prisma-generated/enums';
import { z } from 'zod';
import { isoDateString } from '../_shared/dates.js';
export const createBookingPaymentSchema = z.object({
    bookingId: z.string().min(1),
    externalId: z.string().optional(),
    amount: z.number(),
    currency: z.string().optional(),
    dueDate: isoDateString().optional(),
    method: z.nativeEnum(PaymentMethod).optional(),
    paidAt: isoDateString().optional(),
    status: z.nativeEnum(PaymentStatus),
    type: z.nativeEnum(PaymentType),
});
export const updateBookingPaymentSchema = z.object({
    externalId: z.string().nullish(),
    amount: z.number().optional(),
    currency: z.string().optional(),
    dueDate: isoDateString().nullish(),
    method: z.nativeEnum(PaymentMethod).optional(),
    paidAt: isoDateString().nullish(),
    status: z.nativeEnum(PaymentStatus).optional(),
    type: z.nativeEnum(PaymentType).optional(),
});
